import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Basic from '../Components/Basic/Basic'; 
import moment from 'moment'; 
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Custodian = ({accountSlug:propAccountSlug}) => {
    const navigate = useNavigate(); 
    const systemToken = localStorage.getItem('systemToken') || "";
    const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
     
    const [defaultCurrencyIcon, setDefaultCurrencyIcon] = useState('$');
    const [defaultCurrency, setDefaultCurrency] = useState('AUD');
    const [subac, setSubac] = useState([]);
    const [activeSubac, setActiveSubac] = useState(1);
    const [localStorageData, setLocalStorageData] = useState({}); // Renamed from localStorage
    const [activeTab, setActiveTab] = useState('transactions'); // New state for tab management
    const [custodian, setCustodian] = useState({
        ac_balance: 0,
        default_currency_balance: 0,
        userac_name: 'Properties Management',
        userac_reference_code: '#',
        userac_establish_date: ''
    }); 
    const [timer, setTimer] = useState(undefined);
    
    // Chart state
    const [last12Months] = useState([
        moment().subtract(11, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(10, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(9, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(8, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(7, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(6, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
    ]);
    const [activeChart, setActiveChart] = useState(1);
    const [onChart, setOnChart] = useState(0);
    // const [chart1, setChart1] = useState([0, 0, 0, 0]);
    // const [chart2, setChart2] = useState([0, 0, 0]);
    // const [chart3, setChart3] = useState([0, 0, 0, 0, 0, 0]);
    // const [chart4, setChart4] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    // const [chart5, setChart5] = useState([0, 0]);

    
    
    const [chart1, setChart1] = useState([1000, 2000, 1500, 3000]);
    const [chart2, setChart2] = useState([2500, 3000, 3500]);
    const [chart3, setChart3] = useState([4000, 4500, 5000, 5500, 6000, 6500]);
    const [chart4, setChart4] = useState([7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12500]);
    const [chart5, setChart5] = useState([13000, 13500]);

    // Chart options
     
    // Chart options
  const chartOptions1 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };

  

  const chartOptions2 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions3 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 
  const chartOptions4 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: last12Months
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions5 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };


    const getAccountSlugFromStorage = () => {
        return window.localStorage.getItem('active_page') || 'custodian';
    };
    
    // Force crypto for this component - you can make this dynamic later
    const accountSlug = propAccountSlug || 'custodian';
    
    // Debug: log what accountSlug is being used
    // console.log('Current accountSlug:', accountSlug);


    const getAccountColors = (slug) => {
        const colorMap = {
          'paymaster': {
            gradient: 'bg-purple-gradient',
            tailwindGradient: 'from-purple-600 to-pink-200',
            bgClass: 'bg-purple-gradient',
            color: '#7957F5',
            colorName: 'purple',
            textColor: 'text-white',
            isDark: false
          },
          'fum': {
            gradient: 'bg-yellow-gradient', 
            tailwindGradient: 'from-orange-400 to-yellow-500',
            bgClass: 'bg-yellow-gradient',
            color: '#fdad41',
            colorName: 'orange',
            textColor: 'text-white',
            isDark: false
          },
          'securities': {
            gradient: 'bg-black-gradient',
            tailwindGradient: 'from-gray-600 to-gray-700',
            bgClass: 'bg-black-gradient',
            color: '#494949',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          },
          'property': {
            gradient: 'bg-brown-gradient',
            tailwindGradient: 'from-amber-700 to-amber-800',
            bgClass: 'bg-brown-gradient',
            color: '#ad8e8e',
            colorName: 'brown',
            textColor: 'text-white',
            isDark: false
          },
          'commodities': {
            gradient: 'bg-blue-gradient',
            tailwindGradient: 'from-blue-400 to-blue-500',
            bgClass: 'bg-blue-gradient',
            color: '#33bfff',
            colorName: 'blue',
            textColor: 'text-white',
            isDark: false
          },
          'custodian': {
            gradient: 'bg-dark-gradient',
            tailwindGradient: 'from-gray-900 to-black',
            bgClass: 'bg-dark-gradient',
            color: '#0a0909',
            colorName: 'dark',
            textColor: 'text-white',
            isDark: true
          },
          'my-investment': {
            gradient: 'bg-green-gradient',
            tailwindGradient: 'from-green-500 to-green-400',
            bgClass: 'bg-green-gradient',
            color: '#22b931',
            colorName: 'green',
            textColor: 'text-white',
            isDark: false
          },
          'crypto': {
            gradient: 'bg-crypto',
            tailwindGradient: 'from-indigo-900 to-indigo-950',
            bgClass: 'bg-crypto',
            color: '#08003b',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          },
          'private-wealth': {
            gradient: 'bg-crypto',
            tailwindGradient: 'from-indigo-900 to-indigo-950',
            bgClass: 'bg-crypto',
            color: '#08003b',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          }
        };
        
        return colorMap[slug] || colorMap['fum']; // Default to crypto colors
      };
      
      const accountColors = getAccountColors(accountSlug);

    // Chart data functions
    const getChartData = (data, labels) => ({
        labels: labels,
        datasets: [{
            label: 'Balance',
            data: data,
            borderColor: '#fdad41',
            backgroundColor: 'rgba(253, 173, 65, 0.1)',
            borderWidth: 2,
            fill: true
        }]
    });

    // Chart data
    const chartData1 = getChartData(chart1, ["Week 1", "Week 2", "Week 3", "Week 4"]);
    const chartData2 = getChartData(chart2, [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
    ]);
    const chartData3 = getChartData(chart3, [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
    ]);
    const chartData4 = getChartData(chart4, last12Months);
    const chartData5 = getChartData(chart5, ["0000", "0000"]);

     
   
    const get_account_detail = async (ac_name) => {
        try {
            const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
            const formData = new FormData(); 
            formData.append('user_token', systemToken); 
            formData.append('ac_name', ac_name || accountSlug);
            const response = await fetch(`${BASE_URL}/customer-account`, {
                method: 'POST',
                body: formData
            }); 
            if (response.ok) {
                const data = await response.json();
                // console.log('Account detail data:', data);
                if (data.success === 200) {
                    const fumData = data.ac_info;
                    fumData.userac_establish_date = moment(fumData.userac_establish_date).format('DD MMM, YYYY');
                    setCustodian(fumData); 
                    if (data.ac_data && data.ac_data.subaccounts && data.ac_data.subaccounts.length > 0) {
                        setSubac(data.ac_data.subaccounts); 
                    }
                    // Set active subaccount
                    const subII = window.localStorage.getItem('custodian_subac_id');
                    let subId = '';
                    if (subII && subII > 0) {
                        subId = subII;
                    } else {
                        subId = data.ac_data.subaccounts[data.ac_data.subaccounts.length - 1].subac_id;
                    }
                    setActiveSubac(subId); 
                    const chartInfo = data.chart_data;
                    if (data.chart_data.length > 0) {
                        setChart1(data.chart_data.last_month_chart);
                        setChart2(data.chart_data.three_month_chart);
                        setChart3(data.chart_data.six_month_chart);
                        setChart4(data.chart_data.year_chart.reverse());
                    }
                    
                    // Process all time chart
                    const allChart = chartInfo.all_chart;
                    // console.log('All chart is', chartInfo);
                    
                    const newChart5 = [];
                    const labels = [];
                    
                    if (chartInfo.length === 1) {
                        newChart5.push(0);
                        labels.push((allChart[0].year - 1));
                    }
                    
                    for (let i = 0; i < chartInfo.length; i++) {
                        newChart5.push(allChart[i].balance);
                        labels.push(allChart[i].year);
                    }
                    
                    setChart5(newChart5);
                    setOnChart(1);
                }
            } else {
                console.error('Account detail response not ok:', response.status, response.statusText);
                // Set default values if API fails
                setCustodian({
                    ac_balance: '',
                    default_currency_balance: '',
                    userac_name: '',
                    userac_reference_code: '-',
                    userac_establish_date: '-'
                });
                setSubac([
                     
                ]);
                setActiveSubac(1);
                setOnChart(1);
            }
        } catch (error) {
            console.error('Error fetching account detail:', error);
            console.log("Setting default values due to error");
            // Set default values if API fails
            setCustodian({
                ac_balance: 0,
                default_currency_balance: 0,
                userac_name: '-',
                userac_reference_code: '-',
                userac_establish_date: '-'
            });
            setSubac([
                
            ]);
            setActiveSubac(1);
            setOnChart(1);
        }
    };

 
   

    // Methods
    const openLink = (id) => {
        const link = document.getElementById("URL" + id).value;
        window.open(link, '_blank');
    };

    

    const getUserInfo = async () => {
        const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
        const formData = new FormData();
        formData.append('user_token', systemToken);
        const response = await fetch(`${BASE_URL}/profile`, {
          method: 'POST', 
          body: formData
        });
        if (response.ok) {
            const data = await response.json();
            
            if (data.success === 200) {
              const userInf = data.profile;
              userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
              
              setDefaultCurrency(userInf.default_currency);
              setDefaultCurrencyIcon(userInf.default_currency_icon);
            }
          } else {
            
             
            setDefaultCurrency('AUD');
            setDefaultCurrencyIcon('$');
          }   
    };

    const getAccountDetail = (acName) => {
        get_account_detail(acName)  
    };

    // Effects
    useEffect(() => { 
        document.title = "Custodian Management || Caprock Merchant Platform";
        localStorage.setItem('active_page', 'custodian');
    }, [navigate]);

    useEffect(() => { 
            console.log("useEffect triggered - making API calls");
            getAccountDetail('custodian'); 
    }, [localStorageData]); // Updated dependency

    // Debug useEffect to monitor subac state
    useEffect(() => {
        // console.log('Subac state changed:', subac);
        // console.log('Subac length:', subac ? subac.length : 'undefined');
    }, [subac]);

    return (
        <>
            <Basic />
            

            <div className="w-full p-5 mr-80 box-border mt-5">
                <section className="w-full">
                {/* Top Row - Account Details & Transactions */}
                <div className="flex flex-wrap gap-4 mb-6 w-full">
                    {/* Top Left - Account Details */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
                    <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white`} style={{ minHeight: '300px' }}>
                        <div className="flex flex-wrap -mx-4">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Type</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {accountSlug.charAt(0).toUpperCase() + accountSlug.slice(1).replace('-', ' ')}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Balance</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {defaultCurrency} {defaultCurrencyIcon} {custodian.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </h5>
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 mt-3">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Name</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {custodian.userac_name}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4 overflow-y-auto" style={{ maxHeight: '125px' }}>
                            {subac.map((subac_item) => (
                            <h5 key={subac_item.subac_id} className="text-white text-xs mt-2">
                                {subac_item.subac_name}<br />
                                {subac_item.currency_name} {subac_item.currency_symbol}{subac_item.subac_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </h5>
                            ))}
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 mt-3">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Reference</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            #{custodian.userac_reference_code}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Date Account Established</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {custodian.userac_establish_date}
                            </h5>
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* Top Right - Transactions & Fees */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
                    <div className="bg-white rounded-lg shadow-lg" style={{ minHeight: '300px' }}>
                         
                        <div className="px-1 pl-3 py-3 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <h3 className="text-base font-medium text-gray-500">Custodian Details</h3>
                                <select 
                                    className="bg-gray-50 border border-gray-300 text-black rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                    value={activeSubac}
                                    onChange={(e) => setActiveSubac(parseInt(e.target.value))}
                                >
                                    <option key="sj" value={0} className="text-gray-900">SELECT SUB ACCOUNT</option>
                                    {subac.map((subac_item) => (
                                        <option
                                            key={subac_item.subac_id} 
                                            value={subac_item.subac_id}
                                            className="text-gray-900"
                                        >
                                            {subac_item.subac_name} ({subac_item.currency_name})
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div> 
                        <div className="p-0">
                            {/* Show only active subaccount */}
                            {subac.length > 0 && subac.filter(subac_item => subac_item.subac_id === activeSubac).map((currentSubac) => (
                                <div key={currentSubac.subac_id} className="bg-black text-white" style={{ borderRadius: '10px 10px 0px 0px' }}>
                                    {/* Header */}
                                    <div className="flex justify-start pt-4 pb-3 px-3">
                                        <div className="flex items-center">
                                            <h5 className="text-base text-gray-400 m-0 font-bold">Custodian Details</h5>
                                            <h5 className="text-sm text-white ml-2">Time Stamp: {moment().format('DD/MM/YYYY HH:mm:ss')}</h5>
                                        </div>
                                    </div>

                                    {/* Asset Valuation */}
                                    <div className="px-3">
                                        <div className="flex justify-end">
                                            <div className="flex items-center">
                                                <p className="m-0 text-sm text-white mr-2">Asset Valuation Under Custody</p>
                                                <p className="m-0 text-sm text-white mr-2">{currentSubac.currency_symbol}{currentSubac.custodian_asset_valuation?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</p>
                                        </div>
                                        </div>
                                    </div>

                                    {/* Main Content Grid */}
                                    <div className="px-3 mt-2">
                                        <div className="grid grid-cols-12 gap-0">
                                            {/* Left Column - Issuer & Securities Info */}
                                            <div className="col-span-7 pr-1">
                                                {/* Issuer Information */}
                                                <div className="w-full">
                                                    <div className="flex items-center justify-between">
                                                        <p className="text-sm text-white p-1 bg-gray-800 m-0 w-full">Issuer information</p>
                                                    </div>
                                                    <div className="grid grid-cols-12 gap-0">
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Name</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_issuer_name || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Description</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_issuer_description || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Industry</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_issuer_industry || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Issuing CSD</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_issuer_csd || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Registrar</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_issuer_registrar || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Volume Units</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_issuer_volume_units || 'N/A'}</div>
                                                    </div>
                                                </div>

                                                {/* Securities Information */}
                                                <div className="w-full mt-0">
                                                    <div className="flex items-center justify-between">
                                                        <p className="text-sm text-white p-1 bg-gray-800 m-0 w-full">Securities Information</p>
                                                    </div>
                                                    <div className="grid grid-cols-12 gap-0">
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">MKt Iss</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_security_mkt || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Country</div>
                                                        <div className="col-span-3 text-white p-1 text-xs">{currentSubac.country_name || 'N/A'}</div>
                                                        <div className="col-span-3 text-orange-400 p-1 text-xs">Currency</div>
                                                        <div className="col-span-2 text-white p-1 text-xs">{currentSubac.currency_name || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Rank</div>
                                                        <div className="col-span-3 text-white p-1 text-xs">{currentSubac.custodian_security_rank || 'N/A'}</div>
                                                        <div className="col-span-3 text-orange-400 p-1 text-xs">Series</div>
                                                        <div className="col-span-2 text-white p-1 text-xs">{currentSubac.custodian_security_series || 'N/A'}</div>
                                                        <div className="col-span-12 text-white p-1 text-xs">
                                                            <hr className="my-1 border-gray-600" />
                                                        </div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Coupon Records</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_coupon_records || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Coupon Amount</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_coupon_amount || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Coupon (%)</div>
                                                        <div className="col-span-3 text-white p-1 text-xs">{currentSubac.custodian_coupon || 'N/A'}</div>
                                                        <div className="col-span-2 text-orange-400 p-1 text-xs">Type</div>
                                                        <div className="col-span-3 text-white p-1 text-xs">{currentSubac.custodian_coupon_type || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Cpn Freq</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_coupon_freq || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Day City</div>
                                                        <div className="col-span-3 text-white p-1 text-xs">{currentSubac.custodian_day_city || 'N/A'}</div>
                                                        <div className="col-span-2 text-orange-400 p-1 text-xs">Iss Price</div>
                                                        <div className="col-span-3 text-white p-1 text-xs">{currentSubac.custodian_coupon_issue_price || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Maturity</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_coupon_maturity ? moment(currentSubac.custodian_coupon_maturity).format('DD/MM/YYYY') : 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Iss Sprd</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_coupon_iss_sprd || 'N/A'}</div>
                                                        <div className="col-span-12 text-white p-1 text-xs">
                                                            <hr className="my-1 border-gray-600" />
                                                        </div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Calc Type</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_calc_type || 'N/A'}</div>
                                                        <div className="col-span-8 text-orange-400 p-1 text-xs">Announcement Date</div>
                                                        <div className="col-span-4 text-white p-1 text-xs">{currentSubac.custodian_announcement_date ? moment(currentSubac.custodian_announcement_date).format('DD/MM/YYYY') : 'N/A'}</div>
                                                        <div className="col-span-8 text-orange-400 p-1 text-xs">Interest Accrual Date</div>
                                                        <div className="col-span-4 text-white p-1 text-xs">{currentSubac.custodian_interest_accrual_date ? moment(currentSubac.custodian_interest_accrual_date).format('DD/MM/YYYY') : 'N/A'}</div>
                                                        <div className="col-span-8 text-orange-400 p-1 text-xs">1st Settle Date</div>
                                                        <div className="col-span-4 text-white p-1 text-xs">{currentSubac.custodian_settle1_date ? moment(currentSubac.custodian_settle1_date).format('DD/MM/YYYY') : 'N/A'}</div>
                                                        <div className="col-span-8 text-orange-400 p-1 text-xs">1st Coupon Date</div>
                                                        <div className="col-span-4 text-white p-1 text-xs">{currentSubac.custodian_coupon1_date ? moment(currentSubac.custodian_coupon1_date).format('DD/MM/YYYY') : 'N/A'}</div>
                                                    </div>
                                                </div>
                                        </div>

                                            {/* Right Column - Identifiers, Ratings, Issuance & Custody */}
                                            <div className="col-span-5 pl-0">
                                                {/* Identifiers */}
                                                <div className="w-full">
                                                    <div className="flex items-center justify-between">
                                                        <p className="text-sm text-white p-1 bg-gray-800 m-0 w-full">Identifiers</p>
                                                    </div>
                                                    <div className="grid grid-cols-12 gap-0">
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">ID Number</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_id_number || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">ISIN</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_isin || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">FIGI</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_figi || 'N/A'}</div>
                                                    </div>
                                        </div>

                                                {/* Ratings */}
                                                <div className="w-full mt-0">
                                                    <div className="flex items-center justify-between">
                                                        <p className="text-sm text-white p-1 bg-gray-800 m-0 w-full">Ratings</p>
                                                    </div>
                                                    <div className="grid grid-cols-12 gap-0">
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Moody's</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_rating_moodys || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">S&P</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_rating_sp || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Fitch</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_rating_fitch || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">DBRS</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_rating_dbrs || 'N/A'}</div>
                                                    </div>
                                                    </div>

                                                {/* Issuance & Custody */}
                                                <div className="w-full mt-0">
                                                    <div className="flex items-center justify-between">
                                                        <p className="text-sm text-white p-1 bg-gray-800 m-0 w-full">Issuance & Custody</p>
                                                    </div>
                                                    <div className="grid grid-cols-12 gap-0">
                                                        <div className="col-span-12 text-orange-400 p-1 text-xs">Amt Issued/Outstanding</div>
                                                        <div className="col-span-4 text-white p-1 text-xs">{currentSubac.currency_name || 'N/A'}</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_amount_issued?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 'N/A'}</div>
                                                        <div className="col-span-4 text-white p-1 text-xs">{currentSubac.currency_name || 'N/A'}</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_amount_outstanding?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 'N/A'}</div>
                                                        <div className="col-span-4 text-orange-400 p-1 text-xs">Min Piece/Increment</div>
                                                        <div className="col-span-8 text-white p-1 text-xs">{currentSubac.custodian_min_piece?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 'N/A'} / {currentSubac.custodian_min_increment?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Par Amount</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_par_amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">SKR No.</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">#{currentSubac.custodian_skr_no || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Book</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_book || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Exchange</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_exchange || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Place Of Custody</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custody_place || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Custody Start</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custody_start ? moment(currentSubac.custodian_custody_start).format('DD/MM/YYYY') : 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Custody Finish</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custody_finish ? moment(currentSubac.custodian_custody_finish).format('DD/MM/YYYY') : 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Volume in Custody</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custody_volume || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Beneficiary</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custody_beneficiary || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Custody Type</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custody_type || 'N/A'}</div>
                                                        <div className="col-span-6 text-orange-400 p-1 text-xs">Custodian</div>
                                                        <div className="col-span-6 text-white p-1 text-xs">{currentSubac.custodian_custodian || 'N/A'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Notes Section */}
                                    <div className="px-3 mt-2">
                                        <div className="col-span-12 m-0 p-0">
                                            <hr className="my-1 border-gray-600" />
                                            <div className="text-white text-center">{currentSubac.custodian_notes || 'No notes available'}</div>
                                            <hr className="my-1 border-gray-600" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    

                         
                    </div>

                    </div>
                </div>

                {/* Bottom Row - Portfolio and Chart */}
                <div className="flex flex-wrap gap-4 w-full">
                    {/* Bottom Left - Portfolio */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
                     
                    </div>

                    {/* Bottom Right - Chart */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
                    <div className="bg-white rounded-xl overflow-hidden h-full">
                        {/* Chart Navigation */}
                        <div className="border-b border-gray-200 px-6 py-4">
                        <div className="flex space-x-8">
                            <button 
                            onClick={() => setActiveChart(1)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 1 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            Last Month
                            </button>
                            <button 
                            onClick={() => setActiveChart(2)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 2 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            3M
                            </button>
                            <button 
                            onClick={() => setActiveChart(3)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 3 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            6M
                            </button>
                            <button 
                            onClick={() => setActiveChart(4)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 4 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            Year
                            </button>
                            <button 
                            onClick={() => setActiveChart(5)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 5 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            All
                            </button>
                        </div>
                        </div>

                        {/* Chart Content */}
                        <div className="p-6">
                        {onChart === 1 ? (
                            <div className="h-70 flex items-center justify-center">
                                {activeChart === 1 && <Line data={{ labels: ["Week 1", "Week 2", "Week 3", "Week 4"], datasets: [{ label: 'Balance', data: chart1, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions1} />}
                                {activeChart === 2 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3"], datasets: [{ label: 'Balance', data: chart2, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions2} />}
                                {activeChart === 3 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6"], datasets: [{ label: 'Balance', data: chart3, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions3} />}
                                {activeChart === 4 && <Line data={{ labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], datasets: [{ label: 'Balance', data: chart4, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions4} />}
                                {activeChart === 5 && <Line data={{ labels: ["Year 1", "Year 2"], datasets: [{ label: 'Balance', data: chart5, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions5} />}      
                        
                            </div>
                        ) : (
                            <div className="h-64 flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                            <span className="text-gray-500">Loading...</span>
                            </div>
                        )}
                        </div>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </>
    );
};

export default Custodian;
